/* eslint-disable */
// Resuelve el grupo CNIE de un incidente al que pertenece su tipo específico
// (subtipo del catálogo). Devuelve uno de los slugs que el icon-registry
// tiene registrados: 'seguridad' | 'medico' | 'proteccion_civil' |
// 'servicios_publicos' | 'asistencia' | 'mal_uso' | 'otros_servicios'.
//
// Estrategia (primera que match gana):
//   1. item.category (string) si ya es uno de los slugs conocidos
//   2. item.categoryData.category | attributes.group | attributes.category
//      | attributes.icon (algunos backends exponen directamente el grupo)
//   3. Inferencia heurística por keywords en categoryData.name (el
//      catálogo de subtipos trae nombres descriptivos que delatan el
//      grupo — "ACCIDENTE DE VEHÍCULO AUTOMOTOR..." → médicos, etc.)
//   4. Fallback 'seguridad'.

var KNOWN_SLUGS = {
  seguridad: 1,
  medico: 1,
  proteccion_civil: 1,
  servicios_publicos: 1,
  asistencia: 1,
  mal_uso: 1,
  otros_servicios: 1,
}

// Palabras clave por grupo CNIE v3.0 — iteración 1, se ajusta con
// feedback operativo. El orden importa: patrones más específicos arriba.
var KEYWORD_GROUPS = [
  {
    slug: 'mal_uso',
    patterns: ['LLAMADA MUDA', 'LLAMADAS COLGADAS', 'LLAMADA FALSA', 'MAL USO',
      'OTRAS ALARMAS DE EMERGENCIAS ACTIVADAS', 'BROMA'],
  },
  {
    slug: 'medico',
    patterns: ['LESIONAD', 'PERSONA AGRESIVA', 'ENFERMED', 'CONVULSIONES',
      'INFARTO', 'PARO CARDIACO', 'PARO CARDÍACO', 'SANGRADO', 'QUEMADURA',
      'DIFICULTAD RESPIRATORIA', 'PERSONA INCONSCIENTE', 'OVERDOSIS',
      'OVERDOSE', 'PACIENTE', 'AMBULANCIA', 'MÉDIC', 'MEDIC', 'HERID',
      'INTOXICA', 'EMBARAZ', 'PARTO'],
  },
  {
    slug: 'proteccion_civil',
    patterns: ['INCENDIO', 'FUGA', 'EXPLOSION', 'EXPLOSIÓN', 'INUNDAC',
      'DERRUMB', 'COLAPS', 'SISMO', 'TEMBLOR', 'VOLCAN', 'VOLCÁN',
      'DERRAM', 'PROTECCION CIVIL', 'PROTECCIÓN CIVIL', 'RESCATE',
      'EMERGENCIA QUIMICA', 'EMERGENCIA QUÍMICA', 'ARBOL CAIDO',
      'ÁRBOL CAÍDO', 'CABLES CAIDOS', 'CABLES CAÍDOS',
      'ACCIDENTE DE TRANSITO', 'ACCIDENTE DE TRÁNSITO',
      'ACCIDENTE DE VEHI', 'ACCIDENTE DE MOTOCICLETA',
      'VEHICULO DESCOMPUESTO', 'VEHÍCULO DESCOMPUESTO',
      'VEHICULO ABANDONADO', 'VEHÍCULO ABANDONADO'],
  },
  {
    slug: 'servicios_publicos',
    patterns: ['FALLA', 'FALTA DE AGUA', 'FUGA DE AGUA', 'BACHE',
      'ALUMBRADO', 'SEMAFORO', 'SEMÁFORO', 'DRENAJE', 'BASURA',
      'RESIDUOS', 'COLADERA', 'LIMPIA', 'SERVICIOS PUBLICOS',
      'SERVICIOS PÚBLICOS', 'APAGON', 'APAGÓN'],
  },
  {
    slug: 'asistencia',
    patterns: ['ASISTENCIA', 'ORIENTAC', 'INFORMACION AL PUBLICO',
      'INFORMACIÓN AL PÚBLICO', 'PERDID', 'EXTRAVÍ', 'EXTRAVI',
      'RESCATE ANIMAL', 'ANIMAL PELIGROSO'],
  },
  {
    slug: 'seguridad',
    patterns: ['VIOLENCIA', 'AGRESIV', 'ARMA', 'ROBO', 'ASALTO',
      'HOMICIDIO', 'DISPARO', 'CADAVER', 'CADÁVER', 'RAPTO',
      'DESAPARECID', 'PRIVACION', 'PRIVACIÓN', 'SECUESTRO',
      'NARCOMENUDEO', 'PANDILLA', 'RIÑA', 'RIÑA DE BAR',
      'AMENAZA', 'EXTORSION', 'EXTORSIÓN', 'MALTRATO', 'ABUSO',
      'ACOSO', 'ALLANAMIENTO', 'VANDALISM', 'DROGAS', 'SOSPECHOS'],
  },
  {
    slug: 'otros_servicios',
    patterns: ['OTROS SERVICIOS', 'OTRO'],
  },
]

function _normalizeSlug(val) {
  if (!val || typeof val !== 'string') return null
  var s = val.toLowerCase().trim().replace(/\s+/g, '_').replace(/-/g, '_')
  // 'salud' es un alias histórico de 'medico' que algunos endpoints todavía
  // emiten; lo resolvemos aquí para mantener la fuente única en 'medico'.
  if (s === 'salud') return 'medico'
  // 'PRUEBA' del backend C5 son incidentes de validación operativa, no
  // emergencias reales — se rutean al bucket informativo de Otros Servicios.
  if (s === 'prueba') return 'otros_servicios'
  return KNOWN_SLUGS[s] ? s : null
}

function _inferFromName(name) {
  if (!name || typeof name !== 'string') return null
  var upper = name.toUpperCase()
  for (var i = 0; i < KEYWORD_GROUPS.length; i++) {
    var group = KEYWORD_GROUPS[i]
    for (var j = 0; j < group.patterns.length; j++) {
      if (upper.indexOf(group.patterns[j]) !== -1) return group.slug
    }
  }
  return null
}

// Memo de shapes vistos (por categoryData.name) para debug. Expuesto en
// window.__klnIncidentShapes para que el usuario pueda inspeccionar desde
// consola qué shape está fallando el match.
var _seenShapes = Object.create(null)

/**
 * Devuelve el slug de grupo CNIE del incidente. Nunca retorna null —
 * fallback garantizado a 'seguridad' para que el marker tenga icono.
 */
export function resolveIncidentGroup(item) {
  if (!item) return 'seguridad'

  // 1. Campo directo category como slug de grupo
  var direct = _normalizeSlug(item.category)
  if (direct) {
    _recordShape(item, direct, 'category')
    return direct
  }

  // 2. Campos del catalogo enriquecido
  var cd = item.categoryData
  if (cd) {
    var fromData = _normalizeSlug(cd.category)
      || _normalizeSlug(cd.attributes && cd.attributes.group)
      || _normalizeSlug(cd.attributes && cd.attributes.category)
      || _normalizeSlug(cd.attributes && cd.attributes.icon)
      || _normalizeSlug(cd.attributes && cd.attributes.grupo)
    if (fromData) {
      _recordShape(item, fromData, 'categoryData.fields')
      return fromData
    }
  }

  // 3. Inferencia por nombre humano — el catálogo de subtipos trae
  //    nombres descriptivos que permiten determinar el grupo.
  var name = (cd && cd.name) || item.type || item.typeName
  var fromName = _inferFromName(name)
  if (fromName) {
    _recordShape(item, fromName, 'name-heuristic')
    return fromName
  }

  // 4. Fallback
  _recordShape(item, 'seguridad', 'fallback')
  return 'seguridad'
}

// Mapping declarativo slug CNIE → ícono MDI mostrado en el drawer header,
// los chips del sidebar y cualquier UI que necesite el ícono de la categoría
// (no del marker en el mapa — eso usa los SVGs pre-pintados de theming/).
// Esta tabla es la fuente única de verdad para la UI no-MapLibre.
export var INCIDENT_MDI_BY_CATEGORY = {
  seguridad:          'mdi-police-badge',
  medico:             'mdi-medical-bag',
  proteccion_civil:   'mdi-account-hard-hat',
  servicios_publicos: 'mdi-hand-heart',
  asistencia:         'mdi-comment-account',
  otros_servicios:    'mdi-account-group',
  mal_uso:            'mdi-close-octagon',
}

// CSS var token del tema activo por categoría — debe coincidir con los
// tokens cat-* declarados en theming/palettes/<tema>.js para que header
// del drawer, chip del sidebar, halo del marker e ícono pre-pintado se
// perciban como un solo color por categoría.
export var INCIDENT_CSS_VAR_BY_CATEGORY = {
  seguridad:          'var(--kln-cat-seguridad)',
  medico:             'var(--kln-cat-medico)',
  proteccion_civil:   'var(--kln-cat-proteccion-civil)',
  servicios_publicos: 'var(--kln-cat-servicios-publicos)',
  asistencia:         'var(--kln-cat-asistencia)',
  otros_servicios:    'var(--kln-cat-otros-servicios)',
  mal_uso:            'var(--kln-cat-mal-uso)',
}

// Etiqueta humana de la categoría — usada en el chip del sidebar y en
// "Categoría:" del drawer. Slug → string legible con tilde correcto.
export var INCIDENT_LABEL_BY_CATEGORY = {
  seguridad:          'Seguridad',
  medico:             'Médicos',
  proteccion_civil:   'Protección Civil',
  servicios_publicos: 'Servicios Públicos',
  asistencia:         'Asistencia',
  otros_servicios:    'Otros Servicios',
  mal_uso:            'Mal uso',
}

/**
 * Devuelve el ícono MDI a usar en UI (drawer header, sidebar chips) según
 * la categoría del incidente. Fallback al ícono de seguridad si la
 * categoría no resuelve a uno de los 7 slugs conocidos.
 */
export function getIncidentMdiIcon(item) {
  var slug = resolveIncidentGroup(item)
  return INCIDENT_MDI_BY_CATEGORY[slug] || INCIDENT_MDI_BY_CATEGORY.seguridad
}

/**
 * Devuelve la etiqueta humana de la categoría (Médicos, Seguridad, etc.).
 */
export function getIncidentCategoryLabel(item) {
  var slug = resolveIncidentGroup(item)
  return INCIDENT_LABEL_BY_CATEGORY[slug] || INCIDENT_LABEL_BY_CATEGORY.seguridad
}

/**
 * Devuelve la CSS var del color de categoría para usar en estilos de UI.
 * Sirve para el background del avatar del drawer, fondo de chips, etc.
 */
export function getIncidentColorVar(item) {
  var slug = resolveIncidentGroup(item)
  return INCIDENT_CSS_VAR_BY_CATEGORY[slug] || INCIDENT_CSS_VAR_BY_CATEGORY.seguridad
}

function _recordShape(item, resolvedSlug, via) {
  if (typeof window === 'undefined') return
  var cd = item.categoryData || {}
  var key = cd.name || item.type || '__no_name__'
  if (_seenShapes[key]) return
  _seenShapes[key] = {
    name: cd.name,
    category: item.category,
    type: item.type,
    categoryDataKeys: Object.keys(cd),
    attributesKeys: cd.attributes ? Object.keys(cd.attributes) : null,
    resolvedSlug: resolvedSlug,
    via: via,
  }
  window.__klnIncidentShapes = _seenShapes
}
